import { COUNTRIES_LIST } from "constants/countries.constans";
import { Country } from "types/country.types";

type StoredUserInfo = {
  first_name?: string;
  last_name?: string;
  email?: string;
  phone?: string;
  country_code?: string;
  company?: {
    name?: string;
  };
};

type StoredUser = {
  data?: StoredUserInfo;
};

const storedUserParse = <T>(userData: string): T | null => {
  try {
    return JSON.parse(userData) as T;
  } catch {
    return null;
  }
};

export const getStoredUser = (): StoredUser | null => {
  const userData = localStorage.getItem("user");
  if (!userData) {
    return null;
  }

  try {
    return storedUserParse<StoredUser>(userData);
  } catch {
    return null;
  }
};

export const getCountryFromStoredUser = (): Country | null => {
  const countryCode = getStoredUser()?.data?.country_code;
  if (!countryCode) {
    return null;
  }

  return COUNTRIES_LIST.find((country) => country.countryCode.toUpperCase() === countryCode.toUpperCase()) ?? null;
};

export const updateStoredUserCountryCode = (countryCode: string): void => {
  const storedUser = getStoredUser();
  if (!storedUser?.data) {
    return;
  }

  localStorage.setItem(
    "user",
    JSON.stringify({
      ...storedUser,
      data: {
        ...storedUser.data,
        country_code: countryCode,
      },
    })
  );
};

export const stripDialCodeFromPhone = (phone: string, iso: string): string => {
  const phoneDigits = phone.replace(/\D/g, "");
  const dialCodeDigits = iso.replace(/\D/g, "");

  if (dialCodeDigits && phoneDigits.startsWith(dialCodeDigits)) {
    return phoneDigits.slice(dialCodeDigits.length);
  }

  return phoneDigits;
};
